import { ElementType } from 'react';

import DeleteAccount from './delete-account/DeleteAccount';
import EventModule from './events/EventModule';

export type RouteDefinition = {
  name: string;
  path: string;
  component: () => JSX.Element;
  icon?: ElementType;
};

export const WebRoutes: RouteDefinition[] = [
  {
    name: 'Events',
    path: 'discover',
    component: EventModule,
  },
  {
    name: 'Delete Account',
    path: 'delete-account',
    component: DeleteAccount,
  },
];

export default WebRoutes;
